import { datadogLogs } from "@datadog/browser-logs";
import { extractId } from "@repo/shopify/src/utils";
import { loadBrandPay } from "@tosspayments/brandpay-sdk";
import type { BrandPayInstance as BrandpayInstance } from "@tosspayments/brandpay__types";
import { useCallback, useEffect, useState } from "react";

import useUser from "@hooks/reducerHooks/useUser";

const brandPayClientKey = import.meta.env.VITE_REACT_APP_TOSS_BRAND_PAY_CLIENT_KEY as string;

const useBrandPay = () => {
  const { customer } = useUser();

  const [brandPay, setBrandPay] = useState<BrandpayInstance | null>(null);

  const openBrandPaySetting = useCallback(async () => {
    if (!brandPay) return;

    try {
      await brandPay.openSettings();
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      datadogLogs.logger.error("[TOSS] Failed to Fetch", { message });
      throw new Error(`[TOSS] Failed to Fetch : ${message}`);
    }
  }, [brandPay]);

  useEffect(() => {
    initializeBrandPayInstance();
  }, []);

  const initializeBrandPayInstance = async () => {
    try {
      const initialBrandPay = await loadBrandPay(brandPayClientKey, extractId(customer.id), {
        redirectUrl: "https://mrzkttj5xheyxkyizd7uilzthq0wptiz.lambda-url.ap-northeast-2.on.aws/",
      });

      setBrandPay(initialBrandPay);
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      datadogLogs.logger.error("[TOSS] Failed to Fetch", { message });
      throw new Error(`[TOSS] Failed to Fetch : ${message}`);
    }
  };

  return { openBrandPaySetting };
};

export default useBrandPay;
